// Cashback no Totem/Balcão: config e saldo (auth — o totem roda logado) e as
// contas que espelham o backend (base = itens NÃO promocionais, sem frete).
import axios from "axios";

const API = "/api";
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

export const cashbackApi = {
  config: () => axios.get(`${API}/cashback/config`, auth()),
  saldo: (clienteId) => axios.get(`${API}/cashback/saldo/${clienteId}`, auth()),
};

/** Ativo pra este módulo ("Totem" ou "Balcao")? */
export const cashbackAtivoPara = (cfg, modulo) =>
  !!cfg && !!cfg.ativo && Number(cfg.percentual) > 0 &&
  (cfg.modulos || []).some((m) => String(m).toLowerCase() === String(modulo).toLowerCase());

/** Soma dos itens elegíveis (sem promoção). `ehPromo(item)` decide. */
export const subtotalElegivel = (cart, ehPromo) =>
  (cart || []).reduce((s, i) => s + (ehPromo(i) ? 0 : (i.final_price || i.sale_price || 0) * (i.quantity || 1)), 0);

/** Quanto ganha: base × percentual, em centavos. */
export const estimativaCashback = (cfg, base) => Math.round(Math.max(0, base) * Number(cfg?.percentual || 0)) / 100;

export const fmtBRL = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;
